<template>
    <el-dialog :title="(formData.edit? $t('Update organization contact'):$t('Create organization contact'))"
        :visible.sync="dialogFormVisible" :before-close="handleClose" @open="handleOpen('formData')">
        <el-form label-position="top" :model="formData" ref="formData">
            <input type="hidden" v-model="formData.organization_slug">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('First Name')" prop="first_name" :rules="[{ required: true, message: $t('This field is required')}]">
                    <el-input v-model="formData.first_name"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Last Name')" prop="last_name" :rules="[{ required: true, message: $t('This field is required')}]">
                    <el-input v-model="formData.last_name"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Email')" prop="email" :rules="[{ required: true, message: $t('This field is required')},{ type: 'email', message: $t('Please input valid email address'), trigger: ['blur', 'change'] }]">
                    <el-input v-model="formData.email"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Address')" prop="address" :rules="[{ required: true, message: $t('This field is required'),trigger: ['blur', 'change']}]">
                    <vue-google-autocomplete :country="['ch', 'so', 'iq']" v-model="formData.address" ref="address" id="map"
                        classname="el-input__inner" placeholder="Start typing" v-on:placechanged="getAddressData"
                        @change="handleAddressChange"></vue-google-autocomplete>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Place')" prop="place" :rules="[{ required: true, message: $t('This field is required')}]">
                    <el-input v-model="formData.place"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Zipcode')" prop="zipcode" :rules="[{ required: true, message: $t('This field is required')},{ pattern:/^[1-9]\d{3,4}$/, trigger: ['blur', 'change'], message: $t('Please enter valid zipcode')}]">
                    <el-input type="zipcode" v-model="formData.zipcode"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Phone')" prop="phone">
                    <el-input v-model="formData.phone"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
                <el-form-item :label="$t('Status')">
                    <el-switch v-model="formData.status" active-color="#13ce66" inactive-color="#ff4949" active-value="active"
                        inactive-value="inactive" :active-text="$t('Active')" :inactive-text="$t('Inactive')">
                    </el-switch>
                </el-form-item>
            </el-col>
            <el-col :lg="24">
                <el-form-item>
                    <el-button type="primary" @click="submitForm('formData')">{{ (formData.edit?
                        $t('Update'):$t('Save'))
                        }}</el-button>
                    <el-button type="cancel" @click="$emit('popup',false)">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-col>
            <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
        </el-form>
    </el-dialog>
</template>

<script>
    import VueGoogleAutocomplete from "vue-google-autocomplete";
    export default {
        components: {
            VueGoogleAutocomplete
        },
        props: {
            dialogFormVisible: Boolean,
            organization_slug: String,
            rowData: Object
        },
        data() {
            return {
                formData: {},
                formLabelWidth: "120px"
            };
        },
        methods: {
            handleOpen() {
                this.formData = Object.assign({}, this.rowData);
                this.$nextTick(() => {
                    this.$refs['formData'].clearValidate();
                    this.$refs.address.update(this.formData.address);
                })
            },
            handleClose() {
                this.$emit("popup", false);
            },
            handleAddressChange(address) {
                this.formData.address = address;
                this.$refs["formData"].validateField("address");
            },
            getAddressData: function (addressData, placeResultData, id) {
                this.formData.address = placeResultData.formatted_address;
                this.formData.place = placeResultData.vicinity;
                this.formData.zipcode = addressData.postal_code;
            },
            updateData(row) {
                return request({
                        url: "organization-users/" + row.id,
                        method: "PATCH",
                        data: row
                    })
                    .then(response => {
                        this.$emit('popupupdate', response.data.data);
                        this.$emit('popup', false);
                        this.$notify({
                            title: this.$t('Success'),
                            message: response.data.message,
                            type: "success",
                            offset: 50
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            title: this.$t('Error'),
                            message: error.response.data.message,
                            type: "error",
                            offset: 50
                        });
                    });
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        if (this.formData.edit)
                            return this.updateData(this.formData);
                        request({
                                url: "organization-users",
                                method: "post",
                                data: this.formData
                            })
                            .then(response => {
                                this.$emit("popup", false);
                                this.$emit("popupsave", false);
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/Organizations/ContactForm.vue